import { Text } from '@chakra-ui/react';

const StatusBadge = ({ status, width }: { status: string; width?: string }) => {
  const getColor = (status: string) => {
    switch (status) {
      case 'Order Confirmed':
        return 'status.warning';
      case 'Not Shipped Yet':
        return 'status.warning';
      case 'Delivery In Progress':
        return 'status.warning';
      case 'Shipped':
        return 'status.warning';
      case 'Out For delivery':
        return 'status.warning';
      case 'Delivered':
        return 'status.success';
      case 'Active':
        return '#E8FAF0';
      case 'Cancelled':
        return 'status.error';
      case 'Inactive':
        return '#FFEEED';
      case 'Returned':
        return 'text.secondary';
      default:
        return 'brand.primary.DEFAULT';
    }
  };

  const getBg = (status: string) => {
    switch (status) {
      case 'Order Confirmed':
        return '#FBEEE2';
      case 'Not Shipped Yet':
        return '#FBEEE2';
      case 'Delivery In Progress':
        return '#FBEEE2';
      case 'Shipped':
        return '#FBEEE2';
      case 'Out For Delivery':
        return '#FBEEE2';
      case 'Delivered':
        return '#E8FAF0';
      case 'Active':
        return 'status.success';
      case 'Cancelled':
        return '#FFEEED';
      case 'Inactive':
        return 'status.error';
      case 'Returned':
        return '#F2F4F7';
      default:
        return '#F2F4F7';
    }
  };

  return (
    <>
      <Text
        bg={getBg(status)}
        py="6px"
        px={3}
        fontSize="11px"
        fontWeight="500"
        borderRadius="md"
        color={getColor(status)}
        textTransform={'none'}
        fontFamily={'primary'}
        display={'flex'}
        align={'center'}
        justifyContent={'center'}
        width={width ? width : 'auto'}
      >
        {status === 'Order Confirmed' ? 'Not Yet Shipped' : status}
      </Text>
    </>
  );
};

export default StatusBadge;
